export function getDropdownDefaultValue(defaultValue: any, ref: any) {
  ref.value = defaultValue;

  return defaultValue;
}
